import { apiGet, apiSend } from './http-client'
import type { SysUser, SysRole, SysTenant, SysAudit, PermModule } from '../mock/sysadmin'
export type NoticeType='普通'|'紧急'|'制度'|'更新'
export interface SysNotice {id:string;title:string;type:NoticeType;st:'draft'|'published'|'withdrawn';author:string;content:string;top:boolean;publishAt:string;version:string}
/** 套餐（platform.plan + plan_menu 绑定） */
export interface SysPlan {code:string;name:string;st:'active'|'disabled';userQuota:number;menuCodes:string[];tenantCount:number;createdAt:string}
export interface PlanMenuTree {code:string;name:string;items:{code:string;name:string}[]}
/** Explicit database reads and unavailable commands; never mock fallback. */
export const sysRepo={
  noticeHistory:(id:string)=>apiGet<any[]>('/api/sys/notices/'+encodeURIComponent(id)+'/history'),
  noticeMutate:(action:string,body:Record<string,unknown>)=>apiSend<SysNotice>('POST','/api/sys/notices/'+action,body),
  users: (): Promise<SysUser[]> => apiGet<SysUser[]>('/api/sys/users'),
  roles: (): Promise<SysRole[]> => apiGet<SysRole[]>('/api/sys/roles'),
  tenants: (): Promise<SysTenant[]> => apiGet<SysTenant[]>('/api/sys/tenants'),
  notices: (): Promise<SysNotice[]> => apiGet<SysNotice[]>('/api/sys/notices'),
  audits: (): Promise<SysAudit[]> => apiGet<SysAudit[]>('/api/sys/audits'),
  permModules: (): Promise<PermModule[]> => apiGet<PermModule[]>('/api/sys/perm-modules'),
  userCreate: (_p: Omit<SysUser, 'id' | 'createdAt' | 'lastLogin'>): Promise<SysUser> => Promise.reject(new Error('此管理操作尚未接入，没有修改数据或授权')),
  userUpdate: (_id: string, _p: Partial<SysUser>): Promise<SysUser | null> => Promise.reject(new Error('此管理操作尚未接入，没有修改数据或授权')),
  userToggle: (_id: string): Promise<SysUser | null> => Promise.reject(new Error('此管理操作尚未接入，没有修改数据或授权')),
  userResetPwd: (_id: string): Promise<string> => Promise.reject(new Error('此管理操作尚未接入，没有修改数据或授权')),
  userRemove: (_id: string): Promise<boolean> => Promise.reject(new Error('此管理操作尚未接入，没有修改数据或授权')),
  roleSave: (_p: SysRole): Promise<SysRole> => Promise.reject(new Error('此管理操作尚未接入，没有修改数据或授权')),
  roleToggle: (_id: string): Promise<SysRole | null> => Promise.reject(new Error('此管理操作尚未接入，没有修改数据或授权')),
  roleRemove: (_id: string): Promise<boolean | 'builtin'> => Promise.reject(new Error('此管理操作尚未接入，没有修改数据或授权')),
  roleSetPerms: (id:string,permCodes:string[]):Promise<SysRole|null> => apiSend('PUT','/api/sys/roles/'+encodeURIComponent(id)+'/perms',{permCodes}),
  tenantSave: (p: SysTenant): Promise<SysTenant> => {
    const body = {
      name: p.name,
      planCode: p.planCode,
      adminPersonId: p.adminPersonId,
      userQuota: p.userQuota,
      expireAt: p.expireAt,
    }
    return p.id
      ? apiSend<SysTenant>('PUT', '/api/sys/tenants/' + encodeURIComponent(p.id), body)
      : apiSend<SysTenant>('POST', '/api/sys/tenants', { ...body, code: p.code })
  },
  plans: (): Promise<SysPlan[]> => apiGet<SysPlan[]>('/api/sys/plans'),
  planMenuTree: (): Promise<PlanMenuTree[]> => apiGet<PlanMenuTree[]>('/api/sys/plans/menu-tree'),
  planSave: (p: { code: string; name: string; userQuota: number; menuCodes: string[] }, editing: boolean): Promise<SysPlan> =>
    editing
      ? apiSend<SysPlan>('PUT', '/api/sys/plans/' + encodeURIComponent(p.code), { name: p.name, userQuota: p.userQuota, menuCodes: p.menuCodes })
      : apiSend<SysPlan>('POST', '/api/sys/plans', p),
  planToggle: (code: string): Promise<SysPlan> => apiSend('POST', '/api/sys/plans/' + encodeURIComponent(code) + '/toggle'),
  planRemove: (code: string): Promise<{ code: string; deleted: true }> => apiSend('DELETE', '/api/sys/plans/' + encodeURIComponent(code)),
  tenantToggle: (id: string): Promise<SysTenant | null> => apiSend('POST', '/api/sys/tenants/' + encodeURIComponent(id) + '/toggle'),
  tenantRenew: (id: string, months: number): Promise<SysTenant | null> => apiSend('POST', '/api/sys/tenants/' + encodeURIComponent(id) + '/renew', { months }),
  noticeSave: (_p: SysNotice): Promise<SysNotice> => Promise.reject(new Error('此管理操作尚未接入，没有修改数据或授权')),
  noticePublish: (_id: string): Promise<SysNotice | null> => Promise.reject(new Error('此管理操作尚未接入，没有修改数据或授权')),
  noticeWithdraw: (_id: string): Promise<SysNotice | null> => Promise.reject(new Error('此管理操作尚未接入，没有修改数据或授权')),
  noticeRemove: (_id: string): Promise<boolean> => Promise.reject(new Error('此管理操作尚未接入，没有修改数据或授权')),
}
